import {useTranslation} from "@Translation/hooks/useTranslation";
import {multiModalTranslationKey} from "@SearchResults/features/staticContent/constants/translationKeys";
import TitleAndContent from "@SearchResults/features/staticContent/components/TitleAndContent";
import {TransportTypesType} from "@SearchResults/types/TransportTypes.type";
import getTranslationFromTransportType
    from "@SearchResults/features/staticContent/functions/getTranslationFromTransportType";
import getMinMaxPriceForType from "@SearchResults/features/staticContent/functions/getMinMaxPriceForType";
import {RoutesOrganizedByTransportTypeType} from "@SearchResults/types/RoutesOrganizedByTransportType.type";
import CompanyType from "@SearchResults/types/company/Company.type";
import getTravelTimes from "@SearchResults/features/staticContent/functions/getTravelTimes";

interface WhatTransportTypeIsTheBestContentProps {
    departure: string,
    destination: string,
    singleRoutes: RoutesOrganizedByTransportTypeType,
    companies: Record<string, CompanyType>,
    distanceLandMiles: string,
    fastestVehClass: TransportTypesType,
    slowestVehClass: TransportTypesType,
    priciestVehClass: TransportTypesType,
    cheapestVehClass: TransportTypesType,
}

function WhatTransportTypeIsTheBestContent(props: WhatTransportTypeIsTheBestContentProps) {
    const {
        departure,
        destination,
        singleRoutes,
        companies,
        distanceLandMiles,
        slowestVehClass,
        fastestVehClass,
        priciestVehClass,
        cheapestVehClass,
    } = props

    const fastestVehClassTranslation = getTranslationFromTransportType(fastestVehClass)
    const priciestVehClassTranslation = getTranslationFromTransportType(priciestVehClass)

    const {max: priciestPrice} = getMinMaxPriceForType(singleRoutes[priciestVehClass])
    const {min: cheapestPrice, cheapestCompanyId} = getMinMaxPriceForType(singleRoutes[cheapestVehClass])

    const {minTime: durationMin} = getTravelTimes(singleRoutes[fastestVehClass])
    const {maxTime: durationMax} = getTravelTimes(singleRoutes[slowestVehClass])

    const cheapestOperator = companies[cheapestCompanyId].name

    const title = useTranslation(
        `${multiModalTranslationKey}.what_mode_is_the_best.title`
    )

    const description = useTranslation(
        `${multiModalTranslationKey}.what_mode_is_the_best.desc1`,
        {
            departure,
            destination,
            distanceLandMiles,
            durationMin,
            fastestVehClass: fastestVehClassTranslation,
            durationMax,
            cheapestPrice,
            cheapestOperator,
            priciestVehClass: priciestVehClassTranslation,
            priciestPrice,
        }
    )

    return (
        <TitleAndContent
            title={title}
            content={description}
        />
    )
}

export default WhatTransportTypeIsTheBestContent